import { omitBy } from 'lodash';
import { OmitDeep } from 'type-fest';

import { isTrueObject } from '@willow/shared-iso';

export function removeTypenameFromObject<T>(obj: T): OmitDeep<T, '__typename'> {
  if (Array.isArray(obj)) {
    return obj.map(removeTypenameFromObject) as OmitDeep<T, '__typename'>;
  }

  if (isTrueObject(obj)) {
    return omitBy(
      Object.keys(obj).reduce((acc, key) => {
        if (key !== '__typename') {
          acc[key] = removeTypenameFromObject(obj[key]);
        }
        return acc;
      }, {} as any),
      (_, key) => key === '__typename',
    ) as OmitDeep<T, '__typename'>;
  }

  return obj as OmitDeep<T, '__typename'>;
}
